import { useGetAuthUser } from "@/api/get-user";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { axiosClient } from "@/lib/axios";
import { TrackRecordingViewDto } from "@classview/shared-types";
import { useMutation } from "@tanstack/react-query";

export const trackRecordingView = async (payload: TrackRecordingViewDto) => {
  const response = await axiosClient.post(
    "/analytics/recording-views",
    payload,
  );
  return response.data;
};

export function useTrackRecordingView() {
  const { data: user } = useGetAuthUser();
  const { organisation } = useOrganisation();

  return useMutation({
    mutationFn: (
      payload: Omit<TrackRecordingViewDto, "userId" | "organisationId">,
    ) =>
      trackRecordingView({
        ...payload,
        userId: user?.sub || "",
        organisationId: organisation.id,
      }),
    onError: (error) => {
      console.error("Failed to track recording view:", error);
    },
  });
}
